import React from 'react';
import { useRecoilValue } from 'recoil';
import { useHistory } from 'react-router-dom';
import HomeHeader from '../../shared-components/header/HomeHeader';
import ForgotPassForm from './shared-components/ForgotPassForm';
import { profileAtom } from '../../../atoms/Atoms';

function Register() {
  const user = useRecoilValue(profileAtom);
  const history = useHistory();
  if (user) {
    history.push('/');
  }
  return (
    <div>
      <HomeHeader />
      <ForgotPassForm />
    </div>
  );
}

export default Register;
